import { gql } from 'apollo-angular';

export const RegenerateCampaignDocument = gql`
  mutation regenerate($funnelId: Int!) {
    regenerate(funnelId: $funnelId)
  }
`;
